import { getFirebase } from "react-redux-firebase";
import { applyMiddleware, compose, createStore } from "redux";
import thunk from "redux-thunk";
import rootReducers from "./reducers/rootReducers";

const ativaReduxDevTools =
    process.env.NODE_ENV !== "production" &&
    !!window["__REDUX_DEVTOOLS_EXTENSION__"];

const middlewares = [thunk.withExtraArgument(getFirebase)];

let store;

if (ativaReduxDevTools) {
    store = createStore(
        rootReducers,
        compose(
            applyMiddleware(...middlewares),
            window["__REDUX_DEVTOOLS_EXTENSION__"]()
        )
    );
} else {
    store = createStore(rootReducers, compose(applyMiddleware(...middlewares)));
}

export default store;
